import { TypeChecker } from '@attain-apps/type-guards'

import { ForGroup } from './for-group'
import { ForRecords } from './for-records'
import { ForSingleton } from './for-singleton'
import { ForValue } from './for-value'

// TODO: At runtime, ForGroup nodes always return T[], ForEntity nodes
// return T or T[], ForValue nodes return T or T[]. With ForEntity nodes,
// since we are able to determine isList true, maybe we can have the type
// reflect whether it is T or T[]. Then we can refactor OfAnyType to do
// something like `T extends readonly unknown[] ? ... : ...`

/**
 * Represents all possible nodes. Useful when processing nodes
 */
export type OfAnyType<T = unknown> =
  | ForValue<Maybe.ReadonlyArray<T>>
  | ForRecords<T>
  | ForGroup<T>
  | ForSingleton<T>
export namespace OfAnyType {
  export const isOfAnyType: TypeChecker<OfAnyType> = TypeChecker.Factory.lazy(
    () =>
      TypeChecker.Factory.union(
        ForValue.isForValue,
        ForRecords.isForRecords,
        ForGroup.isForGroup,
        ForSingleton.isForSingleton,
      ),
  ).usingAlias('query.graph.node.OfAnyType')
}
